import { Button, ButtonGroup, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If, Else } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { LibraryViewSelector } from "./library-view-selector"
import { HistoricalLibraryToolbar } from "./historical-library-toolbar"
import { HistoricalLibraryDrawerButton, HistoricalDrawerContent } from "./historical-library-drawer"
import { LibraryBreadcrumbs } from "./library-breadcrumbs"
import { ApproveTaskButton } from "./approve-task-button"
import { BackToListButton } from "./back-to-list-button"

export function LibraryHeader() {
    const {
        breadcrumbs,
        categoryId,
        selectedTaskId,
        readOnly,
        historicalMode,
        activeView,
        isBrowseMode,
        task,
        isFolder,
        checkpoints,
        historicalSupportedFrom,
        libraryAsOf,
        libraryActions,
    } = useBoundContext()

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <LibraryBreadcrumbs
                        breadcrumbs={breadcrumbs}
                        canDelete={!selectedTaskId && categoryId !== "components" && !readOnly}
                        onDelete={libraryActions.onDeleteFolder}
                    />
                </Stack>

                <Stack direction="row" spacing={2} sx={{ pl: 3 }} alignItems="center">
                    <If value={!selectedTaskId && !readOnly}>
                        <If value={isBrowseMode}>
                            <If value={isFolder}>
                                <ButtonGroup size="small" sx={{ whiteSpace: "nowrap" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:cloud-upload-fill" />}
                                        onClick={libraryActions.onUpload}
                                        data-cy="library-upload-zip"
                                    >
                                        Upload Zip
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:folder-add-fill" />}
                                        onClick={libraryActions.onAddFolder}
                                    >
                                        Add Folder
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:layers-fill" />}
                                        onClick={libraryActions.onAddTaskGroup}
                                        data-cy="library-add-task-group"
                                    >
                                        Component Group
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:file-text-fill" />}
                                        onClick={libraryActions.onAddFile}
                                    >
                                        Import File
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:plus-fill" />}
                                        onClick={libraryActions.onAddTask}
                                        data-cy="library-add-task"
                                    >
                                        Add Component
                                    </Button>
                                </ButtonGroup>
                                <Else>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Iconify icon="eva:plus-fill" />}
                                        sx={{ whiteSpace: "nowrap" }}
                                        onClick={libraryActions.onAddTask}
                                    >
                                        Add Component
                                    </Button>
                                </Else>
                            </If>
                        </If>
                    </If>

                    <If value={selectedTaskId}>
                        <If value={selectedTaskId !== "new"}>
                            <If value={!readOnly}>
                                <ButtonGroup size="small" sx={{ whiteSpace: "nowrap" }}>
                                    <Button
                                        data-cy="delete-component-button"
                                        color="error"
                                        onClick={libraryActions.onDeleteTask}
                                        startIcon={<Iconify icon="eva:trash-2-fill" />}
                                    >
                                        Delete
                                    </Button>
                                    <ApproveTaskButton task={task} />
                                    <BackToListButton />
                                </ButtonGroup>
                                <Else>
                                    <ButtonGroup size="small" sx={{ whiteSpace: "nowrap" }}>
                                        <BackToListButton />
                                    </ButtonGroup>
                                </Else>
                            </If>
                            <Else>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleBackToList}
                                    startIcon={<Iconify icon="eva:arrow-back-fill" />}
                                    sx={{ whiteSpace: "nowrap" }}
                                >
                                    Back to List
                                </Button>
                            </Else>
                        </If>
                    </If>

                    <If value={!historicalMode}>
                        <LibraryViewSelector view={activeView} onSelectView={libraryActions.onSelectView} />
                    </If>

                    <HistoricalLibraryDrawerButton historicalMode={historicalMode} />
                </Stack>
            </Stack>

            <HistoricalDrawerContent>
                <HistoricalLibraryToolbar
                    baselineCreatedAt={historicalSupportedFrom}
                    checkpoints={checkpoints}
                    historicalMode={historicalMode}
                    libraryAsOf={libraryAsOf}
                    onClearHistoricalMode={libraryActions.onClearHistoricalMode}
                    onSetLibraryAsOf={libraryActions.onSetLibraryAsOf}
                    unsupportedHistoricalView={false}
                    vertical
                />
            </HistoricalDrawerContent>
        </>
    )

    function handleBackToList() {
        libraryActions.onSelectTask(null)
    }
}
